import TourType from "@/components/TourType";


export default function TourTypePage() {
  return (
    <div>
      <TourType/>
    </div>
  )
}
